export default __webpack_public_path__ + "static/media/288.d4070fe5.png";